import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  mainURL = 'api/payment/';
  constructor(private http: HttpClient, private router: Router) {}

  sendPaymentRequest(payment: any) {
    return this.http.post(
      environment.apiUrl + this.mainURL + 'initiate',
      payment
    );
  }

  getProduct(productKey: string) {
    return this.http
      .get('assets/products.json')
      .toPromise()
      .then((products: any) => {
        const product = products.find((item: any) => item.name === productKey);
        if (product) {
          console.log(product);
          return product;
        }

        const parts = (productKey || '')
          .split(',')
          .map((part) => part.trim())
          .filter(Boolean);

        if (!parts.length) {
          return undefined;
        }

        const resolvedParts = parts
          .map((part) => products.find((item: any) => item.name === part))
          .filter(Boolean);

        if (resolvedParts.length !== parts.length) {
          console.warn('Missing product entry for key:', productKey);
          return undefined;
        }

        const amount = resolvedParts.reduce(
          (sum: number, item: any) => sum + Number(item.amount || 0),
          0,
        );

        const combinedProduct = {
          name: productKey,
          amount,
          description: resolvedParts
            .map((item: any) => item.description)
            .filter(Boolean)
            .join(' + '),
        };

        console.log(combinedProduct);
        return combinedProduct;
      });
  }

  getProducts() {
    return this.http.get(environment.apiUrl + this.mainURL + 'getProducts');
  }

  getPayments() {
    return this.http.get(environment.apiUrl + this.mainURL + 'getPayments');
  }

  setProducts() {
    this.http.get('assets/products.json').subscribe((res: any) => {
      return this.http
        .post(environment.apiUrl + this.mainURL + 'setProducts', res)
        .subscribe((res) => {
          res;
        });
    });
  }

  checkIsProductPurchased(productName: string): Promise<boolean> {
    let userId = localStorage.getItem('userId');
    return new Promise((resolve, reject) => {
      this.http
        .post(
          environment.apiUrl + this.mainURL + userId + '/checkProductStatus',
          productName
        )
        .subscribe(
          (isPurchased) => {
            if (isPurchased) {
              resolve(true);
            } else {
              resolve(false);
            }
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  checkIsGeneratedCVPurchased(generatedCvId: string) {
    return this.http.get<any>(
      environment.apiUrl +
        'api/generatecv/checkGeneratedCvStatus/' +
        generatedCvId
    );
  }

  checkGeneratedCvStatus(serviceSystemId: string) {
    return this.http.get<any>(
      environment.apiUrl + 'api/generatecv/getCvData/' + serviceSystemId
    );
  }
  checkIsGeneratedCLPurchased(generatedClId: string) {
    return this.http.get<any>(
      environment.apiUrl +
        'api/coverletter/checkGeneratedClStatus/' +
        generatedClId
    );
  }
  checkGeneratedClStatus(serviceSystemId: string) {
    return this.http.get<any>(
      environment.apiUrl + 'api/coverletter/getClData/' + serviceSystemId
    );
  }
checkIsGeneratedLinkedinPurchased(serviceSystemId: string) {
    return this.http.get<any[]>(environment.apiUrl + 'api/enhanced-linkedins').pipe(
      map((linkedins) => linkedins.find((l) => l.id === serviceSystemId))
    );
  }
}
